import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_BASE, PROFILE_IMG_BASE } from "@config/env";



const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

export default function ForgotPasswordPage() {
  const [email,   setEmail]   = useState("");
  const [busy,    setBusy]    = useState(false);
  const [success, setSuccess] = useState("");
  const [error,   setError]   = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setSuccess("");
    if (!emailPattern.test(email)) { setError("Enter a valid email address"); return; }
    setBusy(true);
    const fd = new FormData(); fd.append("email", email);
    const res = await axios.post(`${API_BASE}forgot-password`, fd).then(r=>r.data).catch(()=>null);
    setBusy(false);
    if (res?.status === 1) { setSuccess(res.message || "Reset link sent! Check your inbox."); setEmail(""); }
    else setError(res?.message || "Unable to find your account details.");
  };

  return (
    <div style={{ minHeight:"100vh", background:"#F3F4F6", display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div style={{ width:"100%", maxWidth:440 }}>
        {/* Logo */}
        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div style={{ fontSize:22, fontWeight:800, color:"#111827", letterSpacing:"-0.03em" }}>
            Firm<span style={{color:"#2563EB"}}>Connector</span>
          </div>
        </div>

        <div style={{ background:"#fff", borderRadius:20, boxShadow:"0 4px 24px rgba(0,0,0,0.06)", padding:"32px 32px 28px", border:"1px solid #E5E7EB" }}>
          <div style={{ marginBottom:24 }}>
            <div style={{ width:44, height:44, borderRadius:12, background:"#EFF6FF", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:14 }}>
              <i className="fa-solid fa-lock" style={{ fontSize:18, color:"#2563EB" }} />
            </div>
            <h1 style={{ fontSize:20, fontWeight:800, color:"#111827", margin:0 }}>Forgot Password?</h1>
            <p style={{ fontSize:13, color:"#6B7280", margin:"6px 0 0" }}>Enter your registered email to receive a reset link.</p>
          </div>

          {success && (
            <div style={{ display:"flex", alignItems:"flex-start", gap:10, padding:"12px 14px", background:"#F0FDF4", border:"1px solid #BBF7D0", borderRadius:10, marginBottom:18 }}>
              <i className="fa-solid fa-circle-check" style={{ color:"#16A34A", fontSize:14, marginTop:1, flexShrink:0 }} />
              <div style={{ fontSize:13, color:"#14532D" }}>{success}</div>
            </div>
          )}

          {error && (
            <div style={{ display:"flex", alignItems:"flex-start", gap:10, padding:"12px 14px", background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:10, marginBottom:18 }}>
              <i className="fa-solid fa-circle-exclamation" style={{ color:"#DC2626", fontSize:14, marginTop:1, flexShrink:0 }} />
              <div style={{ fontSize:13, color:"#DC2626" }}>{error}</div>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom:20 }}>
              <label style={{ fontSize:12, fontWeight:700, color:"#374151", display:"block", marginBottom:6, textTransform:"uppercase", letterSpacing:"0.05em" }}>
                Email Address
              </label>
              <div style={{ position:"relative" }}>
                <i className="fa-solid fa-envelope" style={{ position:"absolute", left:12, top:"50%", transform:"translateY(-50%)", color:"#9CA3AF", fontSize:13, pointerEvents:"none" }} />
                <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="Enter your email address" autoComplete="off"
                  style={{ width:"100%", boxSizing:"border-box", padding:"11px 12px 11px 38px", border:"1.5px solid #E5E7EB", borderRadius:10, fontSize:14, outline:"none", fontFamily:"inherit", color:"#111827", transition:"all 0.18s" }}
                  onFocus={e=>{e.target.style.borderColor="#2563EB";e.target.style.boxShadow="0 0 0 3px rgba(79,70,229,0.1)"}}
                  onBlur={e=>{e.target.style.borderColor="#E5E7EB";e.target.style.boxShadow="none"}} />
              </div>
            </div>

            <div style={{ display:"flex", gap:8 }}>
              <Link to="/login" style={{ flex:1 }}>
                <button type="button" style={{ width:"100%", padding:"11px", borderRadius:10, border:"1.5px solid #E5E7EB", background:"#fff", fontSize:13, fontWeight:600, color:"#6B7280", cursor:"pointer", fontFamily:"inherit" }}>
                  Cancel
                </button>
              </Link>
              <button type="submit" disabled={busy || !email} className="fc-btn fc-btn-md fc-btn-primary"
                style={{ flex:2, borderRadius:10, opacity: (busy||!email) ? 0.7 : 1 }}>
                {busy ? <><i className="fa-solid fa-spinner fa-spin" style={{fontSize:12}} /> Sending...</> : "Send reset link"}
              </button>
            </div>
          </form>
        </div>

        <div style={{ textAlign:"center", marginTop:20, fontSize:13, color:"#9CA3AF" }}>
          Remember your password? <Link to="/login" style={{ color:"#2563EB", fontWeight:600, textDecoration:"none" }}>Sign in</Link>
        </div>
      </div>
    </div>
  );
}
